import type { AnyFieldApi } from "@tanstack/react-form";
import type { ZodTypeAny } from "zod";

/**
 * Adapt a zod schema into a TanStack Form field validator. Returns the first
 * issue message (or undefined when valid). Use per-field:
 *
 *   <form.Field name="email" validators={{ onChange: zodField(emailSchema) }}>
 */
export function zodField(schema: ZodTypeAny) {
  return ({ value }: { value: unknown }): string | undefined => {
    const result = schema.safeParse(value);
    return result.success ? undefined : result.error.issues[0]?.message;
  };
}

/** First human-readable error for a field, if any. TanStack Form stores
 * validator return values (strings here) in `meta.errors`. */
export function firstFieldError(field: AnyFieldApi): string | undefined {
  const errors = field.state.meta.errors;
  if (!errors || errors.length === 0) return undefined;
  const first = errors[0];
  if (typeof first === "string") return first;
  if (first && typeof first === "object" && "message" in first) {
    return String((first as { message: unknown }).message);
  }
  return String(first);
}
